import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export type UserBlockConfirmModalProps = {
  /** 차단 대상 닉네임 — "OO님을 차단할까요?" 문구에 사용 */
  nickname: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
};

/**
 * 사용자 차단 확인 모달.
 * CommunityPostReportConfirmModal(6406:65672) 의 스타일/구조를 그대로 따른다.
 */
export function UserBlockConfirmModal({
  nickname,
  onCancel,
  onConfirm,
  open,
}: UserBlockConfirmModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel]);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  const displayName = nickname.trim() || '이 사용자';

  return createPortal(
    <div className="user-block-confirm-modal">
      <button
        aria-label="닫기"
        className="user-block-confirm-modal__backdrop"
        onClick={onCancel}
        type="button"
      />
      <div
        aria-describedby="user-block-confirm-modal-desc"
        aria-labelledby="user-block-confirm-modal-title"
        aria-modal="true"
        className="user-block-confirm-modal__dialog"
        role="alertdialog"
      >
        <div className="user-block-confirm-modal__body">
          <div className="user-block-confirm-modal__text">
            <p className="user-block-confirm-modal__title" id="user-block-confirm-modal-title">
              사용자 차단
            </p>
            <p className="user-block-confirm-modal__desc" id="user-block-confirm-modal-desc">
              {displayName}님을 차단할까요? 차단하면 해당 사용자의 게시글과 댓글이 보이지 않습니다.
            </p>
          </div>
          <div className="user-block-confirm-modal__actions">
            <button
              className="user-block-confirm-modal__btn user-block-confirm-modal__btn--secondary"
              onClick={onCancel}
              type="button"
            >
              취소
            </button>
            <button
              className="user-block-confirm-modal__btn user-block-confirm-modal__btn--primary"
              onClick={onConfirm}
              type="button"
            >
              차단
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
